import Alert from '@customink/pigment-react/lib/components/Alert';

import { WCIBMO_NAMES } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { pageViewTag } from '@/utils/metrics';

export default function InvalidZipCode() {
  const quantityType = useOrderQuantityType();
  pageViewTag(
    `checkout/summary/${quantityType}/wcibmo/${WCIBMO_NAMES.INVALID_ZIP_CODE}`,
  );

  return (
    <Alert severity="error">
      Please enter a valid ZIP code to get your price.
    </Alert>
  );
}
